import { render, staticRenderFns } from "./CeldaDateRango.vue?vue&type=template&id=60babd2e&scoped=true"
import script from "./CeldaDateRango.vue?vue&type=script&lang=js"
export * from "./CeldaDateRango.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60babd2e",
  null
  
)

export default component.exports